import { Component } from '@angular/core';
import { SessionStat } from './sessions-stat.model';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { ClientsService } from '../../../services/clients/clients.service';
import { SuperClass } from '../../../superclass/SuperClass';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { WsService } from '../../../services/websocket/WsService';

@Component({
  selector: 'app-sessions-stat',
  templateUrl: './sessions-stat.component.html',
  styleUrls: ['./sessions-stat.component.css'],
})
export class SessionsStatComponent extends SuperClass {
  selectedRow: SessionStat;
  display = false;
  start: Date;
  end: Date;
  nasid;
  session: SessionStat[];
  loading: string = 'none';

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Sessions' },
      {
        label: 'Sessions Statistics',
        routerLink: [{ outlets: { sub: [RouterConst.SESSIONS_SESSION_STAT] } }],
      },
    ]);
    this.selectedRow = new SessionStat();
  }

  reloadData() {
    this.end = new Date();
    this.start = new Date(this.end.getTime() - 24 * 60 * 60 * 1000);
    this.nasid = '';
    this.getSessions();
  }

  getDate(date) {
    if (date) {
      return new Date(date);
    }
  }

  getSessions() {
    const request = {
      start: this.start.getTime(),
      end: this.end.getTime(),
      nasid: this.nasid,
    };
    this.loading = 'block';
    this.http_getSessionStat(request, (response: any) => {
      this.session = response.payload;
      this.loading = 'none';
    });
  }

  selectRow(e) {
    this.selectedRow = new SessionStat(e.data);
  }

  unselectRow() {}

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/sessions/sessions-stat/sessions-stat.component.ts